import { Grid, Typography, withStyles, Checkbox, FormControlLabel, TextField, Select } from '@material-ui/core';
import PropTypes from 'prop-types';
import React__default, { createElement, Component } from 'react';
import _extends from '@babel/runtime/helpers/esm/extends';
import { FormattedMessage, defineMessages, FormattedNumber } from 'react-intl';
import { pure, getDisplayName, branch, renderComponent } from 'recompose';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread';
import classNames from 'classnames';
import germanFlag from 'flag-icon-css/flags/4x3/de.svg';
import gbFlag from 'flag-icon-css/flags/4x3/gb.svg';
import ruFlag from 'flag-icon-css/flags/4x3/ru.svg';
import syFlag from 'flag-icon-css/flags/4x3/sy.svg';
import trFlag from 'flag-icon-css/flags/4x3/tr.svg';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { oneOfPropHasChanged } from '@apoly-42/apoly-utils';

var ErrorTemplate = function ErrorTemplate(_ref) {
  var children = _ref.children;
  return createElement(Grid, {
    container: true,
    justify: "center",
    spacing: 0
  }, createElement(Grid, {
    item: true,
    xs: 12,
    lg: 10
  }, children));
};

ErrorTemplate.propTypes = {
  children: PropTypes.node.isRequired
};

/* eslint-disable react/no-unescaped-entities */

var ApiRequestFailed = function ApiRequestFailed(_ref) {
  var email = _ref.email;
  return React__default.createElement(ErrorTemplate, null, React__default.createElement(Typography, {
    variant: "subheading"
  }, "Sorry, but we couldn't request the called data, so please try again by reloading this page."), React__default.createElement(Typography, {
    variant: "subheading"
  }, "Should this error remain, please contact us at", ' ', React__default.createElement("a", {
    href: "mailto:".concat(email)
  }, email), "."));
};

ApiRequestFailed.propTypes = {
  email: PropTypes.string.isRequired
};
ApiRequestFailed.defaultProps = {};

var ErrorAlert = function ErrorAlert(_ref) {
  var children = _ref.children;
  return React__default.createElement("div", null, React__default.createElement(Typography, null, "Error:"), children);
};

ErrorAlert.propTypes = {
  children: PropTypes.node.isRequired
};
ErrorAlert.defaultProps = {};

var InnerI18nMessage = function InnerI18nMessage(_ref) {
  var message = _ref.message,
      tagName = _ref.tagName,
      values = _ref.values;
  return React__default.createElement(FormattedMessage, _extends({}, message, {
    values: values,
    tagName: tagName
  }));
};

var I18nMessage = pure(InnerI18nMessage);
I18nMessage.propTypes = {
  message: PropTypes.object.isRequired,
  values: PropTypes.object,
  tagName: PropTypes.string
};
I18nMessage.defaultProps = {
  values: undefined,
  tagName: undefined
};

var messages = defineMessages({
  contactUsInCaseThisErrorIsUnexpected: {
    id: 'contactUsInCaseThisErrorIsUnexpected',
    defaultMessage: 'If you think there is an error, please {contactUs}!'
  }
});

var NotFoundTemplate = function NotFoundTemplate(_ref) {
  var children = _ref.children,
      contactUsLink = _ref.contactUsLink,
      align = _ref.align;
  return createElement(Grid, {
    container: true,
    spacing: 16,
    justify: "center"
  }, createElement(Grid, {
    item: true,
    xs: 12,
    lg: 10
  }, children), contactUsLink && createElement(Grid, {
    item: true,
    xs: 12,
    lg: 10
  }, createElement(Typography, {
    align: align
  }, createElement(I18nMessage, {
    message: messages.contactUsInCaseThisErrorIsUnexpected,
    values: {
      contactUs: contactUsLink
    }
  }))));
};

NotFoundTemplate.propTypes = {
  children: PropTypes.node,
  contactUsLink: PropTypes.any,
  align: PropTypes.string
};
NotFoundTemplate.defaultProps = {
  children: null,
  contactUsLink: null,
  align: 'left'
};

var messages$1 = defineMessages({
  pageNotFoundHeaderComponent: {
    id: 'pageNotFoundHeaderComponent',
    defaultMessage: 'Ouch! Something went totally wrong here!'
  },
  pageNotFoundTextComponent: {
    id: 'pageNotFoundTextComponent',
    defaultMessage: "You tried visiting {path}, but we don't know this path. Sorry!"
  }
});

var PageNotFound = function PageNotFound(_ref) {
  var location = _ref.location;
  return React__default.createElement("div", null, React__default.createElement("h1", null, messages$1.pageNotFoundHeader), React__default.createElement("p", null, messages$1.pageNotFoundText));
};

PageNotFound.propTypes = {
  location: PropTypes.object.isRequired
};
PageNotFound.defaultProps = {};

var hasMessage = function hasMessage(error) {
  return error && error.message;
};

var messages$2 = defineMessages({
  unexpectedError: {
    id: 'unexpectedError',
    defaultMessage: 'Sorry! An unexpected error occurred. You probably should reload the page and try again. If the problem persists, please come back later: we are trying to fix it meanwhile.'
  }
});

var getDefaultErrorMessage = function getDefaultErrorMessage(defaultMessage) {
  return defaultMessage || 'Sorry! An unexpected error occurred. You probably should reload the page and try again. If the problem persists, please come back later: we are trying to fix it meanwhile.';
};

var ShowUnknownError = function ShowUnknownError(_ref) {
  var error = _ref.error,
      defaultMessage = _ref.defaultMessage,
      Component$$1 = _ref.component;
  return React__default.createElement(Component$$1, null, hasMessage(error) ? error.message : getDefaultErrorMessage(defaultMessage));
};

ShowUnknownError.propTypes = {
  error: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  defaultMessage: PropTypes.string,
  component: PropTypes.string
};
ShowUnknownError.defaultProps = {
  error: null,
  defaultMessage: null,
  component: 'span'
};

var ThrowErrorComponent = function ThrowErrorComponent(_ref) {
  var error = _ref.error;

  if (!error) {
    throw new Error('ThrowErrorComponent was called without error');
  }

  throw error;
};

ThrowErrorComponent.propTypes = {
  error: PropTypes.object.isRequired
};

var FALayer = function FALayer(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return createElement("span", _extends({
    className: "fa-layers"
  }, props), children);
};

FALayer.propTypes = {
  children: PropTypes.node.isRequired
};

/*
falls man squared mit nutzen will:
  * import the squared icon from the 1x1-dir (e.g. 'flag-icon-css/flags/1x1/gb.svg') and add it to the styles
  * add propType (boolean) squared und wähle entsprechend squared/non-squared css-class
 */

var styles = {
  flagIcon: {
    backgroundSize: 'contain',
    backgroundPosition: '50%',
    backgroundRepeat: 'no-repeat',
    position: 'relative',
    display: 'inline-block',
    width: '1.33333333em',
    lineHeight: '1em',
    '&:before': {
      content: '"\\A0"' // not beautiful, but working, see https://github.com/cssinjs/jss/issues/337

    }
  },
  squared: {
    width: '1em'
  },
  de: {
    backgroundImage: "url(".concat(germanFlag, ")")
  },
  gb: {
    backgroundImage: "url(".concat(gbFlag, ")")
  },
  sy: {
    backgroundImage: "url(".concat(syFlag, ")")
  },
  tr: {
    backgroundImage: "url(".concat(trFlag, ")")
  },
  ru: {
    backgroundImage: "url(".concat(ruFlag, ")")
  }
};

var InnerFlagIcon = function InnerFlagIcon(_ref) {
  var code = _ref.code,
      classes = _ref.classes,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["code", "classes", "className"]);

  return React__default.createElement("span", _extends({
    className: classNames(className, classes.flagIcon, classes[code])
  }, props));
};

var FlagIcon = withStyles(styles)(InnerFlagIcon);
FlagIcon.propTypes = {
  code: PropTypes.oneOf(['gb', 'de', 'sy', 'tr', 'ru'])
};
InnerFlagIcon.propTypes = _objectSpread({}, FlagIcon.propTypes, {
  classes: PropTypes.object.isRequired
});

var InnerFieldCheckbox = function InnerFieldCheckbox(_ref) {
  var field = _ref.field,
      label = _ref.label,
      _onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ["field", "label", "onChange"]);

  return React__default.createElement(FormControlLabel, {
    control: React__default.createElement(Checkbox, _extends({
      id: field.id,
      value: field.name,
      checked: field.value,
      onChange: function onChange(e) {
        field.setValue(!field.value);

        if (_onChange) {
          _onChange(e);
        }
      },
      onBlur: field.plugIsTouched
    }, props)),
    label: label
  });
};
/* eslint-enable react/prop-types */


var FieldCheckbox = pure(InnerFieldCheckbox);

var InnerFieldInput = function InnerFieldInput(_ref) {
  var field = _ref.field,
      props = _objectWithoutProperties(_ref, ["field"]);

  return React__default.createElement(TextField, _extends({
    id: field.id,
    value: field.value,
    onChange: field.setValueFromEvent,
    onBlur: field.plugIsTouched,
    error: !!(field.isTouched && field.error),
    helperText: field.isTouched && field.error && field.error
  }, props));
};
/* eslint-enable react/prop-types */


var FieldInput = pure(InnerFieldInput);

/* eslint-disable react/prop-types */

var InnerFieldSelect = function InnerFieldSelect(_ref) {
  var field = _ref.field,
      label = _ref.label,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["field", "label", "children"]);

  return React__default.createElement(Select, _extends({
    id: field.id,
    value: field.value,
    onChange: field.setValueFromEvent,
    onBlur: field.plugIsTouched,
    error: !!(field.isTouched && field.error),
    helperText: field.isTouched && field.error && field.error
  }, props), children);
};
/* eslint-enable react/prop-types */


var FieldSelect = pure(InnerFieldSelect);

/* eslint-disable react/no-danger */

var JsonLd = function JsonLd(props) {
  return React__default.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(props.data)
    }
  });
};

JsonLd.propTypes = {
  data: PropTypes.any.isRequired
};
JsonLd.defaultProps = {};

var NullComponent = function NullComponent() {
  return null;
};

var PureStyle =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(PureStyle, _React$PureComponent);

  function PureStyle() {
    _classCallCheck(this, PureStyle);

    return _possibleConstructorReturn(this, _getPrototypeOf(PureStyle).apply(this, arguments));
  }

  _createClass(PureStyle, [{
    key: "render",
    value: function render() {
      return React__default.createElement("style", {
        dangerouslySetInnerHTML: {
          __html: this.props.styleHtml
        }
      });
    }
  }]);

  return PureStyle;
}(React__default.PureComponent);
PureStyle.propTypes = {
  styleHtml: PropTypes.string.isRequired
};
PureStyle.defaultProps = {};

var FormattedDigit = function FormattedDigit(_ref) {
  var digits = _ref.digits,
      value = _ref.value,
      style = _ref.style,
      props = _objectWithoutProperties(_ref, ["digits", "value", "style"]);

  return React__default.createElement(FormattedNumber, _extends({
    value: value,
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
    style: style
  }, props));
};

FormattedDigit.propTypes = {
  value: PropTypes.number.isRequired,
  digits: PropTypes.number,
  style: PropTypes.oneOf(['decimal', 'currency', 'percent'])
};
FormattedDigit.defaultProps = {
  digits: null,
  style: 'decimal'
};

var FormattedEuro = function FormattedEuro(_ref) {
  var value = _ref.value,
      props = _objectWithoutProperties(_ref, ["value"]);

  return React__default.createElement(FormattedDigit, _extends({
    value: value // eslint-disable-next-line react/style-prop-object
    ,
    style: "currency",
    currency: "EUR",
    digits: 2
  }, props));
};

var getFormatEuroOption = function getFormatEuroOption() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread({
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }, props);
};
FormattedEuro.propTypes = {
  value: PropTypes.number.isRequired
};
FormattedEuro.defaultProps = {};

var preventClickAndExecute = function preventClickAndExecute(onClick) {
  return function (e) {
    e.preventDefault();
    onClick(e);
  };
};

var BlindAnchor = function BlindAnchor(_ref) {
  var onClick = _ref.onClick,
      href = _ref.href,
      children = _ref.children,
      Component$$1 = _ref.component,
      props = _objectWithoutProperties(_ref, ["onClick", "href", "children", "component"]);

  return React__default.createElement(Component$$1, _extends({
    onClick: preventClickAndExecute(onClick),
    href: href
  }, props), children);
};

BlindAnchor.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func, PropTypes.element])
};
BlindAnchor.defaultProps = {
  href: '#',
  component: 'a'
};

var NoDecoLink = function NoDecoLink(_ref) {
  var style = _ref.style,
      Component$$1 = _ref.component,
      props = _objectWithoutProperties(_ref, ["style", "component"]);

  return React__default.createElement(Component$$1, _extends({
    style: _objectSpread({
      textDecoration: 'none',
      color: 'inherit'
    }, style)
  }, props));
};

NoDecoLink.propTypes = {
  style: PropTypes.object,
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func, PropTypes.element])
};
NoDecoLink.defaultProps = {
  style: null,
  component: 'a'
};

var RenderChild = function RenderChild(_ref) {
  var children = _ref.children;
  return children;
};

RenderChild.propTypes = {
  children: PropTypes.element.isRequired
};

var ShowNode = function ShowNode(_ref) {
  var show = _ref.show,
      children = _ref.children,
      TagName = _ref.tag;
  return show ? React__default.createElement(TagName, null, children) : null;
};

ShowNode.propTypes = {
  show: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  tag: PropTypes.string
};
ShowNode.defaultProps = {
  tag: 'div'
};

var Spacing = function Spacing(props) {
  return React__default.createElement("div", {
    style: {
      marginTop: props.spacing / 2,
      marginBottom: props.spacing / 2
    }
  });
};

Spacing.propTypes = {
  spacing: PropTypes.oneOf([8, 16, 40, 80])
};
Spacing.defaultProps = {
  spacing: 16
};

var WithIcon = function WithIcon(props) {
  return React__default.createElement("div", {
    style: {
      display: 'flex'
    }
  }, props.iconLeft && React__default.createElement(FontAwesomeIcon, {
    icon: props.icon,
    style: {
      marginTop: 'auto',
      marginBottom: 'auto',
      marginRight: props.spacing / 2,
      fontSize: props.iconFontSize
    }
  }), React__default.createElement("div", {
    style: {
      marginTop: 'auto',
      marginBottom: 'auto',
      marginLeft: props.iconLeft ? props.spacing / 2 : 0,
      marginRight: props.iconLeft ? 0 : props.spacing / 2
    }
  }, props.children), !props.iconLeft && React__default.createElement(FontAwesomeIcon, {
    icon: props.icon,
    style: {
      marginTop: 'auto',
      marginBottom: 'auto',
      marginLeft: props.spacing / 2,
      fontSize: props.iconFontSize
    }
  }));
};

WithIcon.propTypes = {
  iconLeft: PropTypes.bool,
  icon: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  spacing: PropTypes.number,
  iconFontSize: PropTypes.any
};
WithIcon.defaultProps = {
  iconLeft: false,
  spacing: 8,
  iconFontSize: 16
};

var addDelayToLoadingProp = function addDelayToLoadingProp(delay, propNameToObserve, delayedPropName) {
  return function (WrappedComponent) {
    var AddDelayToPropWrapper =
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(AddDelayToPropWrapper, _React$Component);

      function AddDelayToPropWrapper(props) {
        var _this;

        _classCallCheck(this, AddDelayToPropWrapper);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(AddDelayToPropWrapper).call(this, props));

        _this.setPastDelay = function (val) {
          return val !== _this.state.pastDelay && _this.setState({
            pastDelay: val
          });
        };

        _this.handlePropChange = function () {
          if (_this.props[propNameToObserve]) {
            // only start delay when prop is true (eg when isLoading)
            _this.timeoutId = window.setTimeout(function () {
              return _this.setPastDelay(true);
            }, delay);
          } else {
            // set default to false
            _this.setPastDelay(false);
          }
        };

        _this.state = {
          pastDelay: false
        };
        _this.timeoutId = null;
        return _this;
      }

      _createClass(AddDelayToPropWrapper, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          if (this.props[propNameToObserve]) {
            this.handlePropChange();
          }
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          if (oneOfPropHasChanged(prevProps, this.props, [propNameToObserve])) {
            window.clearTimeout(this.timeoutId);
            this.handlePropChange();
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          window.clearTimeout(this.timeoutId);
        }
      }, {
        key: "render",
        value: function render() {
          var newProps = _objectSpread({}, this.props, _defineProperty({}, delayedPropName, this.state.pastDelay));

          return createElement(WrappedComponent, newProps);
        }
      }]);

      return AddDelayToPropWrapper;
    }(Component);

    AddDelayToPropWrapper.displayName = "addDelayToProp(".concat(getDisplayName(WrappedComponent), ")");
    return AddDelayToPropWrapper;
  };
};

var preventExecutionAfterUnmount = function preventExecutionAfterUnmount(propName) {
  return function (BaseClass) {
    var isUnmounted = false;

    var WithPreventExecutionAfterUnmount =
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(WithPreventExecutionAfterUnmount, _React$Component);

      function WithPreventExecutionAfterUnmount() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, WithPreventExecutionAfterUnmount);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(WithPreventExecutionAfterUnmount)).call.apply(_getPrototypeOf2, [this].concat(args)));

        _this.callIfNotUnmounted = function () {
          if (!isUnmounted) {
            var _this$props;

            (_this$props = _this.props)[propName].apply(_this$props, arguments);
          }
        };

        return _this;
      }

      _createClass(WithPreventExecutionAfterUnmount, [{
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          isUnmounted = true;
        }
      }, {
        key: "render",
        value: function render() {
          var newProps = _objectSpread({}, this.props, _defineProperty({}, propName, this.callIfNotUnmounted));

          return React__default.createElement(BaseClass, newProps);
        }
      }]);

      return WithPreventExecutionAfterUnmount;
    }(React__default.Component);

    WithPreventExecutionAfterUnmount.displayName = BaseClass.displayName;
    return WithPreventExecutionAfterUnmount;
  };
};

var throwIf = function throwIf(prediction) {
  return branch(prediction, renderComponent(ThrowErrorComponent));
};
var throwIfError = throwIf(function (props) {
  return props.error;
});

var paired = 0;
var idCount = 0;
var newClientId = function newClientId() {
  idCount += 1;

  if (idCount >= 10000) {
    paired += 1;
    idCount = 0;
  }

  return "cId-".concat(paired, "-").concat(idCount);
};
var withClientId = function withClientId(propName) {
  return function (WrappedComponent) {
    var Enhanced =
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(Enhanced, _React$Component);

      function Enhanced() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, Enhanced);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Enhanced)).call.apply(_getPrototypeOf2, [this].concat(args)));
        _this.cId = newClientId();
        return _this;
      }

      _createClass(Enhanced, [{
        key: "render",
        value: function render() {
          var otherProps = _extends({}, this.props);

          return React__default.createElement(WrappedComponent, _extends({}, otherProps, _defineProperty({}, propName, this.cId)));
        }
      }]);

      return Enhanced;
    }(React__default.Component);

    Enhanced.propTypes = {};
    Enhanced.displayName = "withClientId(".concat(WrappedComponent.displayName, ")");
    return Enhanced;
  };
};

var withReactRef = function withReactRef(refName) {
  return function (WrappedComponent) {
    var Enhanced =
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(Enhanced, _React$Component);

      function Enhanced() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, Enhanced);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Enhanced)).call.apply(_getPrototypeOf2, [this].concat(args)));
        _this.root = React__default.createRef();
        return _this;
      }

      _createClass(Enhanced, [{
        key: "render",
        value: function render() {
          return React__default.createElement(WrappedComponent, _extends({}, this.props, _defineProperty({}, refName, this.root)));
        }
      }]);

      return Enhanced;
    }(React__default.Component);

    Enhanced.propTypes = {};
    Enhanced.displayName = "withReactRef(".concat(WrappedComponent.displayName, ")");
    return Enhanced;
  };
};

var withSnackbar = function withSnackbar(showSnackbarPropName, SnackbarComponent) {
  return function (BaseComponent) {
    var WithSnackbar =
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(WithSnackbar, _React$Component);

      function WithSnackbar(props) {
        var _this;

        _classCallCheck(this, WithSnackbar);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(WithSnackbar).call(this, props));
        _this.state = {
          isOpen: false,
          message: null
        };

        _this.hideSnackbar = function () {
          return _this.setState({
            isOpen: false
          });
        };

        _this.withSnackbarProps = _defineProperty({}, showSnackbarPropName, function (message) {
          return _this.setState({
            isOpen: true,
            message: message
          });
        });
        return _this;
      }

      _createClass(WithSnackbar, [{
        key: "render",
        value: function render() {
          return React__default.createElement(React__default.Fragment, null, React__default.createElement(SnackbarComponent, {
            open: this.state.isOpen,
            onClose: this.hideSnackbar,
            message: this.state.message
          }), React__default.createElement(BaseComponent, _extends({}, this.props, this.withSnackbarProps)));
        }
      }]);

      return WithSnackbar;
    }(React__default.Component);

    WithSnackbar.displayName = "withSnackbar(".concat(BaseComponent.displayName, ")");
    return WithSnackbar;
  };
};

var withSnackbarProps = function withSnackbarProps(propName, handleClosePropName, snackbarShouldOpenFromProps) {
  return function (BaseComponent) {
    var WithSnackbarProps =
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(WithSnackbarProps, _React$Component);

      function WithSnackbarProps(props) {
        var _this;

        _classCallCheck(this, WithSnackbarProps);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(WithSnackbarProps).call(this, props));
        _this.state = {
          isOpen: false
        };

        _this.handleClose = function () {
          return _this.setState({
            isOpen: false
          });
        };

        return _this;
      }

      _createClass(WithSnackbarProps, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
          var snackbarShouldOpen = snackbarShouldOpenFromProps(nextProps);

          if (snackbarShouldOpenFromProps(this.props) !== snackbarShouldOpen && snackbarShouldOpen) {
            this.setState({
              isOpen: true
            });
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _ref;

          return React__default.createElement(BaseComponent, _extends({}, this.props, (_ref = {}, _defineProperty(_ref, propName, this.state.isOpen), _defineProperty(_ref, handleClosePropName, this.handleClose), _ref)));
        }
      }]);

      return WithSnackbarProps;
    }(React__default.Component);

    WithSnackbarProps.displayName = "withSnackbarProps(".concat(BaseComponent.displayName, ")");
    return WithSnackbarProps;
  };
};

var withToggleState = function withToggleState(propName, toggleHandlerPropName, defaultBoolean) {
  return function (BaseComponent) {
    var WithToggleState =
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(WithToggleState, _React$Component);

      function WithToggleState(props) {
        var _this;

        _classCallCheck(this, WithToggleState);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(WithToggleState).call(this, props));
        _this.state = {
          toggle: typeof defaultBoolean === 'function' ? !!defaultBoolean(props) : !!defaultBoolean
        };

        _this.toggleProp = function () {
          return _this.setState({
            toggle: !_this.state.toggle
          });
        };

        return _this;
      }

      _createClass(WithToggleState, [{
        key: "render",
        value: function render() {
          var _ref;

          return React__default.createElement(BaseComponent, _extends({}, this.props, (_ref = {}, _defineProperty(_ref, toggleHandlerPropName, this.toggleProp), _defineProperty(_ref, propName, this.state.toggle), _ref)));
        }
      }]);

      return WithToggleState;
    }(React__default.Component);

    WithToggleState.displayName = "withToggleState(".concat(BaseComponent.displayName, ")");
    return WithToggleState;
  };
};

export { addDelayToLoadingProp, newClientId, withClientId, withReactRef, PureStyle, Spacing, JsonLd, ApiRequestFailed, I18nMessage, ErrorTemplate, FormattedDigit, FormattedEuro, BlindAnchor, RenderChild, ShowNode, FALayer, FieldInput, FieldSelect, FieldCheckbox, FlagIcon, NullComponent, getFormatEuroOption, ErrorAlert, PageNotFound, NotFoundTemplate, ShowUnknownError, ThrowErrorComponent, withSnackbar, withSnackbarProps, preventExecutionAfterUnmount, withToggleState, throwIfError, WithIcon, NoDecoLink };
//# sourceMappingURL=apoly-components.esm.js.map
